<div class="articles-lobby">
    <div *ngIf="pageData" class="articles-lobby_inner-top">
        <picture class="inner-top-back">
            <source media="(min-width: 640px)" srcset="/Content/Images/empty.gif"
                data-srcset="{{pageData.backgroundImage}}">
            <img [src]="pageData.backgroundImageMobile" />
        </picture>
        <div class="inner-top-content">
            <div class="inner-top-content_mob-image">
                <img src="/Content/Images/triangles/footer2.png" />
            </div>
            <div class="inner-top-content_content-body">
                <h1 class="inner-top-content_content-body_title">{{pageData.pageTitle}}</h1>
            </div>
        </div>
    </div>

    <div *ngIf="!pageData" class="articles-lobby_inner-top skeleton" >
        <div class="inner-top-back"><app-skeleton/></div>

        <div class="inner-top-content">

            <app-skeleton class="inner-top-content_mobile-image-skeleton"/>
            <div class="inner-top-content_content-body">
                <h1 class="inner-top-content_content-body_title"></h1>
            </div>
        </div>
    </div>

    <div class="news-artcicles">
        <div class="news-artcicles__top">
            <div class="container">
                <div class="form form--article-test filters-lobby" [ngClass]="{'hide-mobile': isMobile}">
                    <div class="search-box">
                        <mat-form-field *ngIf="pageData" appearance="outline" class="mb-0">
                            <input matInput [placeholder]="pageData.searchPlaceHolder" [value]="searchTerm" (input)="onInputChange($event)" [disabled]="isLoading">
                            <mat-icon matPrefix [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
                        </mat-form-field>

                        <app-skeleton [height]="50" *ngIf="!pageData"/>
                    </div>
                    <ng-container *ngIf="pageData">
                        <app-custom-datepicker
                            *ngIf="pageData"
                            [placeholder]="pageData.startDatePlaceHolder"
                            [selectedDate]="searchRequest.startDate" 
                            [disabled]="isLoading"
                            (dateChange)="changeStartDate($event)"
                        ></app-custom-datepicker>
                        <app-custom-datepicker 
                            *ngIf="pageData"
                            [placeholder]="pageData.endDatePlaceHolder"
                            [selectedDate]="searchRequest.endDate" 
                            [disabled]="isLoading"
                            (dateChange)="changeEndDate($event)"
                        ></app-custom-datepicker>

                        <app-multi-select 
                            *ngIf="pageData && pageData.articlesContentTypes && pageData.articlesContentTypes.length"
                            [filterItems]="pageData.articlesContentTypes" 
                            [selectedValue]="searchRequest.contentTypes"
                            [label]="pageData.articlesContentTypesPlaceholder" 
                            [disabled]="isLoading"
                            (changeValue)="contentTypesChanged($event)"
                        ></app-multi-select>
                    </ng-container>

                    <ng-container *ngIf="!pageData">
                        <app-skeleton [height]="50" *ngFor="let _ of [].constructor(3)"/>
                    </ng-container>
                </div>

                <div class="news-artcicles__checkers" [ngClass]="{'hide-mobile': isMobile}">
                    <app-custom-checkboxes 
                        *ngIf="pageData && pageData.articlesSubjectsList && pageData.articlesSubjectsList.length"
                        [items]="pageData.articlesSubjectsList"
                        [selectedItemsKeys]="searchRequest.subjectsList" 
                        [disabled]="isLoading"
                        (itemChecked)="articlesSubjectsChange($event)"
                    ></app-custom-checkboxes>

                    <ng-container *ngIf="!pageData">
                        <app-skeleton [height]="36" [width]="70" *ngFor="let _ of [].constructor(10)"/>
                    </ng-container>
                </div>

                <div class="lobby-filters-mobile"  [ngClass]="{'hide-mobile': !isMobile}">
                    <div class="search-box">
                        <mat-form-field *ngIf="pageData" appearance="outline" class="mb-0">
                            <input matInput [placeholder]="pageData.searchPlaceHolder" [value]="searchTerm" (input)="onInputChange($event)" [disabled]="isLoading">
                            <mat-icon matPrefix [svgIcon]="'search'" class="square-icon search-icon"></mat-icon>
                        </mat-form-field>

                        <app-skeleton *ngIf="!pageData" [height]="48"/>
                    </div>
                    <div class="slide-up-header" *ngIf="pageData" (click)="openFiltersMobilePopup()">
                        <div class="filter-icon">
                            <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
                        </div>
                        <div class="filter-text">{{pageData.mobileFiltersLabel}}</div>
                    </div>                    
                    <div class="slide-up-header" *ngIf="!pageData">
                        <div class="filter-icon">
                            <app-skeleton [width]="36" [height]="36" />
                        </div>
                        <div class="filter-text"><app-skeleton [type]="'text'" [symbolsCount]="20"/></div>
                    </div>
                    <div class="lobby-filters-mobile-popup" *ngIf="pageData && showFiltersMobileModal">
                        <div class="lobby-filters-mobile-popup_content">
                            <span class="close" (click)="closeFiltersMobilePopup()">
                                &times;
                            </span>
                            <div class="slide-up-header">
                                <div class="filter-icon">
                                    <img src="/Content/Images/icons/filter.svg" alt="" width="36" height="36" />
                                </div>
                                <div class="filter-text">{{pageData.mobileFiltersLabel}}</div>
                            </div>
                            <div class="slide-up-filters-content">
                                <app-expansion-date-panel
                                    [title]="pageData.mobileDateRangeFilterLabel"
                                    [startDatePlaceHolder]="pageData.startDatePlaceHolder"
                                    [endDatePlaceHolder]="pageData.endDatePlaceHolder"
                                    [fromDate]="searchRequest.startDate"
                                    [toDate]="searchRequest.endDate"
                                    [disabled]="isLoading"
                                    (fromDateChanged)="changeStartDate($event)"
                                    (toDateChanged)="changeEndDate($event)"
                                ></app-expansion-date-panel>
                                <app-expansion-mobile-multi-select-panel
                                    *ngIf="pageData.articlesContentTypes && pageData.articlesContentTypes.length"
                                    [filterItems]="pageData.articlesContentTypes" 
                                    [label]="pageData.articlesContentTypesPlaceholder" 
                                    [disabled]="isLoading"
                                    (changeValue)="contentTypesChangedMobile($event)"
                                ></app-expansion-mobile-multi-select-panel>
                                <app-expansion-mobile-multi-select-panel
                                    *ngIf="pageData.articlesSubjectsList && pageData.articlesSubjectsList.length"
                                    [filterItems]="pageData.articlesSubjectsList" 
                                    [label]="pageData.mobileSubjectsListLabel" 
                                    [disabled]="isLoading"
                                    (changeValue)="articlesSubjectsChangeMobile($event)"
                                ></app-expansion-mobile-multi-select-panel>
                            </div>
                            <div class="slide-up-filters-bottom">
                                <div class="slide-up-filters-bottom__text">
                                  {{getDisplayingCountText(pageData.mobileResultText)}}
                                </div>
                                <button class="slide-up-filters-bottom__clear-btn link" (click)="clearSearch($event)" [disabled]="isLoading">
                                    {{pageData.cleanSearchText}}
                                </button>
                                <button class="slide-up-filters-bottom__search-submit" (click)="closeFiltersMobilePopup()">
                                    {{pageData.mobileDisplayResults}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="news-artcicles__list">
                <ng-container *ngIf="getContentShowing() || mobileNextPageLoading">
                    <app-articles-and-news-lobby-item *ngFor="let item of pageData?.articlesList.articlesList"
                        class="slide-min slide-min--list" [article]="item"
                        [articlesContentTypes]="pageData.articlesContentTypes"/>
                </ng-container>
                <ng-container *ngIf="!pageData || mobileNextPageLoading || isLoading">
                    <app-articles-and-news-lobby-item 
                        *ngFor="let _ of [].constructor(pageData ? pageData.pageSize : 6)"
                        class="slide-min slide-min--list skeleton" 
                        [article]="" 
                        [articlesContentTypes]=""
                        [isLoadingItem]="true"/>
                </ng-container>
            </div>

            <div *ngIf="!getContentShowing() && !isLoading" class="search-catalog__empty">
                <div class="empty-filter">
                    <div class="title title--sub">{{pageData.noResultTitle}}</div>
                    <div class="title title--mini" [innerHTML]="pageData.noResulstText"></div>
                    <button class="link link--title" (click)="clearSearch($event)">
                        <div class="link__text">{{pageData.cleanSearchText}}</div>
                    </button>
                    <div class="empty-filter__img">
                        <img [src]="pageData.noResultsImage" width="202" height="283">
                    </div>
                </div>
            </div>

            <div *ngIf="getContentShowing()" class="articles-lobby-footer" [ngClass]="{'hide-mobile': isMobile}">
                <app-paginator [totalResults]="pageData.articlesList.totalResults" [currentPage]="currentPage"
                    [pageSize]="pageData.pageSize" (pageChanged)="goToPage($event)"
                    [paginatorContainerClass]="paginatorContainerCssClass" [activeLiClass]="'active'"
                    [activeLinkClass]="'active'" [liClass]="'pagination__link'" [linkClass]="'pagination__link_a'"
                    [rangeSize]="rangeSize"></app-paginator>
            </div>

            <button *ngIf="isMobile && getMoreMobileCount() > 0 && getContentShowing()" 
                    class="button button--main" data-show-more="" (click)="nextPageMobile()">
                <span class="button__text"> {{pageData.moreResultsMobile}} ({{getMoreMobileCount()}})</span>
            </button>
        </div>
    </div>
</div>